import * as Yup from 'yup';

import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';

export enum AddCollaboratorFieldNames {
  Email = 'email',
  IsOwner = 'isOwner',
  FirstName = 'firstName',
  LastName = 'lastName',
}

export interface AddCollaboratorFormValues {
  [AddCollaboratorFieldNames.Email]: string;
  [AddCollaboratorFieldNames.IsOwner]: boolean;
  [AddCollaboratorFieldNames.FirstName]: string;
  [AddCollaboratorFieldNames.LastName]: string;
}

const validationRules: ValidationRules<keyof AddCollaboratorFormValues> = {
  [AddCollaboratorFieldNames.Email]: Yup.string()
    .email('Email invalide')
    .required("L'email est requis"),
  [AddCollaboratorFieldNames.IsOwner]: Yup.boolean().required(),
  // Nom et prénom optionnels : nécessaires uniquement si on crée un nouveau compte.
  // La validation côté soumission gère ce cas (logique conditionnelle dans le composant).
  [AddCollaboratorFieldNames.FirstName]: Yup.string().nullable(),
  [AddCollaboratorFieldNames.LastName]: Yup.string().nullable(),
};

export const addCollaboratorFormConfig = createFormConfig<AddCollaboratorFormValues>(
  validationRules,
  {
    [AddCollaboratorFieldNames.Email]: '',
    [AddCollaboratorFieldNames.IsOwner]: false,
    [AddCollaboratorFieldNames.FirstName]: '',
    [AddCollaboratorFieldNames.LastName]: '',
  },
);
